import React from 'react'
import { Coupon } from '../../models/coupon';
import { fontSizeToViewport, formatNumber } from '../../utils/function-utils';
import { useInitialCofig } from '../../hooks/initialConfig-hook';

//AVCDAAV.002  20/03/2025  Add code for Adding coupon template component

type Props = {
    couponData: Coupon;
    size: "small" | "large";
    fullWidth?: boolean; 
    handleClickCoupon?: () => void;
}

export const CouponTemplate = (props: Props) => {
    const couponImageType = props.couponData.couponImage !== "";
    const { initialConfig } = useInitialCofig();
    return (
        <React.Fragment>
            {couponImageType && (
                <div className={`coupon-template custom ${props.size === "small" ? "small" : "large"}`} onClick={props.handleClickCoupon} style={{width: props.fullWidth ? "100%" : window.innerWidth >= 375 ? "90%" : "100%"}} >
                    <div className='before-coupon' 
                        style={{
                            backgroundColor: "#FFFFFF",
                            width: "100px",
                        }}>
                    </div>
                    <div className='after-coupon-image' 
                        style={{
                            backgroundImage: `radial-gradient(circle at 100% 50%,transparent 10px, 
                                ${props.couponData.color ? `${props.couponData.color.startsWith("#") ? props.couponData.color : `#${props.couponData.color}`}` : "white"} 10px)`,
                            width: "calc(100% - 100px)"
                        }}>
                    </div>
                    <div className='coupon-header'>
                        <div className='header-box'>
                            <img src={`${props.couponData.couponImage}`} alt="coupon-logo" className='coupon-logo'/>
                        </div>
                    </div>
                    <div className='coupon-body'>
                        <div className='coupon-box-body-top'>
                            <div className='body-header-top' style={{...initialConfig.styles.coupon_header_style, visibility: props.couponData.headerCaption.trim() !== "" ? "visible" : "hidden"}}>
                                {props.couponData.headerCaption.trim() === "" ? "header" : props.couponData.headerCaption}
                            </div>
                            <div className='body-header-center' style={{...initialConfig.styles.coupon_header2_style, visibility: props.couponData.headerCaption2.trim() !== "" ? "visible" : "hidden", ...fontSizeToViewport(initialConfig.styles.coupon_header2_style['font-size'])}}>
                                {!props.couponData.headerCaption2 ? 
                                    props.couponData.points > 0 ? 
                                    <span >{formatNumber("en-US",props.couponData.points)} <span style={{color: "unset"}}>Point</span></span> : 
                                    <span >ฟรี</span>
                                    : props.couponData.headerCaption2.trim() === "" ? "header2" : props.couponData.headerCaption2
                                }
                            </div>
                        </div>
                        <div className='body-header-bottom' style={{...initialConfig.styles.coupon_caption_header_style}}>{props.couponData.couponCaption}</div>
                    </div>
                </div>
            )}
            {/* //CouponText normal */}
            {/* {!couponImageType && (
                <div className={`coupon-template custom ${props.size === "small" ? "small" : "large"}`} onClick={props.handleClickCoupon}>
                    <div className='before-coupon' 
                        style={{
                            backgroundImage: `radial-gradient(circle at 0% 50%,transparent 10px, 
                                ${props.couponData.color ? `${props.couponData.color.startsWith("#") ? props.couponData.color : `#${props.couponData.color}`}` : "white"} 10px)`,
                            width: "50%"
                        }}>
                    </div>
                    <div className='after-coupon' 
                        style={{
                            backgroundImage: `radial-gradient(circle at 100% 50%,transparent 10px, 
                                ${props.couponData.color ? `${props.couponData.color.startsWith("#") ? props.couponData.color : `#${props.couponData.color}`}` : "white"} 10px)`,
                            width: "50%"
                        }}>
                    </div>
                    <div className='coupon-body coupon-body-text-template'>
                        <div className='body-header-box'>
                            {props.couponData.points > 0 ? 
                                <span >{formatNumber("en-US",props.couponData.points)} <span style={{color: "unset"}}>Point</span></span> : 
                                <span >ฟรี</span>
                            }
                        </div>
                        <div className='body-header-box-header'>{props.couponData.headerCaption}</div>
                        <div className='body-content-box'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{props.couponData.couponCaption}</div>
                    </div>
                </div>
            )} */}
            {/* //C-CouponText normal */}

            {/* //Coupon whitout angle */}
            {!couponImageType && (
                <div className={`coupon-template custom ${props.size === "small" ? "small" : "large"}`} onClick={props.handleClickCoupon} style={{width: props.fullWidth ? "100%" : "90%"}}>
                    <div className='after-coupon' 
                        style={{
                            backgroundImage: `radial-gradient(circle at 100% 50%,transparent 12px, 
                            ${props.couponData.color ? `${props.couponData.color.startsWith("#") ? props.couponData.color : `#${props.couponData.color}`}` : "white"} 12px)`,
                            width: "100%"
                        }}> 
                    </div>
                    <div className='coupon-body'>
                        <div className='coupon-box-body-top'>
                            <div className='body-header-top' style={{...initialConfig.styles.coupon_header_style, visibility: props.couponData.headerCaption.trim() !== "" ? "visible" : "hidden"}}>
                                {props.couponData.headerCaption.trim() === "" ? "header" : props.couponData.headerCaption}
                            </div>
                            <div className='body-header-center' style={{...initialConfig.styles.coupon_header2_style, visibility: props.couponData.headerCaption2.trim() !== "" ? "visible" : "hidden", ...fontSizeToViewport(initialConfig.styles.coupon_header2_style['font-size'])}}>
                                {!props.couponData.headerCaption2 ? 
                                    props.couponData.points > 0 ? 
                                    <span >{formatNumber("en-US",props.couponData.points)} <span style={{color: "unset"}}>Point</span></span> : 
                                    <span >ฟรี</span>
                                    : props.couponData.headerCaption2.trim() === "" ? "header2" : props.couponData.headerCaption2
                                }
                            </div>
                        </div>
                        <div className='body-header-bottom' style={{...initialConfig.styles.coupon_caption_header_style}}>{props.couponData.couponCaption}</div>
                    </div>
                </div>
            )}
            {/* //C-Coupon whitout angle */}

            {/* //Coupon with angle */}
            {/* {!couponImageType && (
                <div className={`coupon-template custom ${props.size === "small" ? "small" : "large"}`} onClick={props.handleClickCoupon}>
                    <div className='coupon-angle'></div>
                    <div className='coupon-angle-inside'>
                        <div>คูปอง</div>
                        <div>ส่วนลด</div>
                    </div>
                    <div className='after-coupon' 
                        style={{
                            backgroundImage: `radial-gradient(circle at 100% 50%,transparent 20px, 
                                ${props.couponData.color ? `${props.couponData.color.startsWith("#") ? props.couponData.color : `#${props.couponData.color}`}` : "white"} 20px)`,
                            width: "100%"
                        }}>
                    </div>
                    <div className='coupon-body'>
                        <div className='coupon-box-body-top'>
                            <div className='body-header-top'>{props.couponData.couponCaption}</div>
                            <div className='body-header-center'>
                                {props.couponData.points > 0 ? 
                                    <span >{formatNumber("en-US",props.couponData.points)} <span style={{color: "unset"}}>Point</span></span> : 
                                    <span >ฟรี</span>
                                }
                            </div>
                        </div>
                        <div className='body-header-bottom'>{props.couponData.headerCaption}</div>
                    </div>
                </div>
            )} */}
        {/* //C-Coupon with angle */}
        </React.Fragment>
    )
}

//C-AVCDAAV.002  20/03/2025  Add code for Adding coupon template component
